<template>
  <div class="container">
    <div v-if="!subscriptionComp">
      <div class="text-center hidden-xs">
        <h1 v-if="userRoleComp == 'Client'">Become a member</h1>
        <h1 style="color: #926d9e" v-if="userRoleComp == 'Sitter'">
          Go Premium <i style="font-size: 32px" class="fa fa-paw" />
        </h1>
        <p
          v-if="userRoleComp == 'Sitter'"
          style="margin-bottom: 0px"
          class="lead"
        >
          Get paid to cuddle with pets. Receive 5x more bookings.
        </p>

        <p
          v-if="userRoleComp == 'Client'"
          style="margin-bottom: 0px"
          class="lead"
        >
          The best experience for cats and dogs.
        </p>
        <br />
      </div>

      <div class="hidden-sm hidden-md hidden-lg">
        <h1 v-if="userRoleComp == 'Client'" class="text-center">
          Become a member
        </h1>
        <h1
          style="color: #926d9e"
          v-if="userRoleComp == 'Sitter'"
          class="text-center"
        >
          Go Premium <i style="font-size: 32px" class="fa fa-paw" />
        </h1>

        <p
          v-if="userRoleComp == 'Sitter'"
          style="margin-bottom: 0px"
          class="lead"
        >
          Get paid to cuddle with pets. Receive 5x more bookings.
        </p>
        <p
          v-if="userRoleComp == 'Client'"
          style="margin-bottom: 0px"
          class="lead"
        >
          The best experience for cats and dogs.
        </p>
        <br />
      </div>
      <div
        class="modal fade"
        id="paypalModal"
        data-backdrop="static"
        show="true"
        data-keyboard="false"
        role="dialog"
        aria-labelledby="modalLabel"
        tabindex="-1"
      >
        <div class="modal-dialog">
          <div
            style="padding: 0px"
            class="modal-content col-sm-offset-2 col-sm-8"
          >
            <div class="modal-header">
              <h3 style="margin-top: 0px; margin-bottom: 0px">
                <i class="fa fa-credit-card"></i> Payment method
              </h3>
            </div>
            <div class="modal-body" style="overflow: hidden; margin-top: 0px">
              <div class="well" style="margin-top: 0px; margin-bottom: 0px">
                <div>
                  <p style="margin-top: 0px; margin-bottom: 0px">
                    <strong>{{ selectedPlan.Description }}</strong> package
                  </p>
                  <br />
                  <small class="h6">
                    Notice: we dont re-charge your card when the plan
                    expires.</small
                  >
                </div>
              </div>
              <br />
              <div id="paypal-button-container"></div>

              <div class="pull-right">
                <br />
                <button class="btn btn-default" @click="hidePaypalModal()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="pendingModal"
        data-backdrop="static"
        show="true"
        data-keyboard="false"
        role="dialog"
        aria-labelledby="modalLabel"
        tabindex="-1"
      >
        <div class="modal-dialog">
          <div class="modal-content col-sm-offset-2 col-sm-8">
            <div class="modal-header">
              <h3 style="margin-top: 0px; margin-bottom: 0px">
                <i class="fa fa-credit-card"></i> Payment Pending
              </h3>
            </div>
            <div class="modal-body" style="overflow: hidden; margin-top: 0px">
              <div class="well" style="margin-top: 0px; margin-bottom: 0px">
                <div>
                  <h3 class="text-center">
                    Pending Payment Completion, please wait...
                  </h3>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>

      <div class="plans">
        <div class="col-md-4 remove-margins-xs" v-for="plan in plansDto">
          <div class="card-body">
            <div v-if="plan.DaysDuration == 365" class="ribbon">Best Value</div>
            <div class="card-header">
              <h4 class="text-center font-weight-normal">
                {{ plan.Description }}
              </h4>
            </div>

            <div class="text-center">
              <h1 class="card-title pricing-card-title">
                ${{ plan.Price }} <small class="text-muted">/ mo</small>
              </h1>
              <ul class="list-unstyled">
                <div v-if="plan.PlanType == 2">
                  <li>Booking requests from to all</li>
                  <li>More cuddles and more profit</li>
                  <li>Priority over basic profiles</li>
                  <li>Premium Account profile badge</li>
                </div>
                <div v-if="plan.PlanType == 1">
                  <li>Access to all pet sitters</li>
                  <li>Unlimited booking requests</li>
                  <li>Meet and greet amazing people</li>
                </div>
              </ul>
              <div style="padding: 15px">
                <button
                  type="button"
                  @click="showPaypalModal(plan)"
                  class="btn btn-lg btn-info btn-block"
                >
                  Upgrade Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center hidden-xs">
        <p style="margin-bottom: 0px">
          Dupaws donates 10% of all subscriptions to feeding and helping stray
          animals.
        </p>
      </div>

      <div class="hidden-sm hidden-md hidden-lg">
        <p style="margin-bottom: 0px; margin-left: 20px">
          Dupaws donates 10% of all subscriptions to feeding and helping stray
          animals.
        </p>
      </div>
      <div></div>
    </div>
    <!--if subscription is needed div-->
    <div v-else>
      <h1 class="text-center">You already have a valid subscription</h1>
      <div
        style="margin-top: 15px; padding: 0px"
        class="col-md-6 col-md-offset-3"
      >
        <button @click="goHome()" class="btn btn-success btn-block">
          Go home
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../../auth/index";
import store from "../../data/store";
import VueScript2 from "vue-script2";

export default {
  name: "subscribe",
  data() {
    return {
      myTotal: 100,
      paypalNonce: "",
      braintreeClient: "",
      selectedPlan: "",
      paypalDone: false,
      plansDto: "",
      paymentDto: "",
      paypalPayDto: {
        //object used to be sent to back end server when payment is made to paypal.
        PlanId: "",
        SubscriptionId: "", //only used when server sends back a success response..
        PaypalEmail: "", //the email user used to make this payment.
        PaypalFirstName: "", //the first_name user used to make this payment.
        PaypalLastName: "", //the last_name user used to make this payment.
        PaypalTransId: "", //paypal transaction id
        InvoiceNumber: "", //this is the only piece shared from us to paypal, invoice_number.,
        Status: "",
        PaypalAmount: "",
        PaypalCurrency: "",
      },
      testDto: {
        intent: "sale",
        payer: {
          //https://developer.paypal.com/docs/api/payments/#definition-payer
          payment_method: "paypal",
          payer_info: {
            email: "m.khomakho-buyer@dupaws.com",
            first_name: "Mohammed",
            last_name: "Khomakho",
            billing_address: {
              line1: "12345",
              city: "Dubai",
              state: "Dubai",
              country_code: "AE",
              postal_code: "12345",
              phone: "0551764478",
            },
          },
        },
        application_context: {
          brand_name: "Dupaws.com",
          locale: "en_AE",
          shipping_preference: "NO_SHIPPING",
        },
        transactions: [
          {
            amount: {
              total: "50",
              currency: "USD",
            },
            description: "Dupaws 3 month subscription.",
            invoice_number: "48787589634336",
            payment_options: {
              allowed_payment_method: "INSTANT_FUNDING_SOURCE",
            },
            payee: {
              email: "business@dupaws.com",
            },
          },
        ],
      },
    };
  },
  mounted() {
    var self = this;
    this.$ga.page(this.$router);

    self.initPlans();
    fbq("track", "Lead", { content_name: "Visit Subscribe Page" });
    self.$ga.event("Visit Subscribe Page");
  },
  updated() {
    var self = this;
    $("input").focus(function () {
      self.scrollPosition = window.scrollY;
    });
    $("input").blur(function () {
      // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
      self.$SmoothScroll(self.scrollPosition, 350);
    });

    // $zopim(function() {
    //     $zopim.livechat.badge.hide();
    // });

    if (self.paypalDone == false) {
      VueScript2.load("https://www.paypalobjects.com/api/checkout.min.js").then(
        function () {
          if (self.subscriptionAllowedComp == false) {
            self.swalAlert();
          }
          if (self.subscriptionComp == false) {
            self.initPaypalButton();
            self.paypalDone = true;
          }
        }
      );
    }
  },
  methods: {
    swalAlert() {
      var self = this;
      swal(
        {
          title: "You are getting closer!",
          text: "To upgrade your account, you must have a completed and approved Pet Sitter account first",
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn-success",
          confirmButtonText: "Setup Profile",
          closeOnConfirm: true,
          html: true,
        },
        function () {
          self.$router.push({ path: "/sitter-profile-edit/about" });
        }
      );
    },
    goHome: function () {
      this.$router.push({ path: "/" });
    },
    showPaypalModal(plan) {
      var self = this;
      self.selectedPlan = plan;
      if (self.subscriptionAllowedComp == false) {
        self.swalAlert();
        return;
      }

      self
        .initPaymentDto(self.selectedPlan)
        .then(function (paymentDto_server) {
          self.paymentDto = paymentDto_server;
          fbq("track", "InitiateCheckout", {
            currency: "USD",
            content_name: self.selectedPlan.Description,
            value: self.selectedPlan.TotalPrice,
          });
          self.$ga.event(
            "Initiate Checkout",
            self.selectedPlan.Description,
            self.selectedPlan.TotalPrice
          );
          $("#paypalModal").modal("show");
        })
        .fail(function (error) {
          console.log(error);
        });
    },

    hidePaypalModal() {
      $("#paypalModal").modal("hide");
    },
    showPendingModal() {
      $("#pendingModal").modal("show");
    },
    hidePendingModal() {
      $("#pendingModal").modal("hide");
    },
    initPaymentDto: function (selectedPlan) {
      var self = this;
      return $.ajax({
        type: "GET",
        url:
          "https://www.dupaws.com/services/api/initPaymentDto/" +
          selectedPlan.PlanId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        crossDomain: true,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          //data is returned in calling functions.
        },
        error: function (data, status, error) {
          console.log(
            "failed to get Sitter Profile Status" + data.responseText
          );
        },
      });
    },
    initPlans() {
      var self = this;
      $.ajax({
        type: "GET",
        url: "https://www.dupaws.com/services/api/initPlans",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        crossDomain: true,
        success: function (data) {
          self.plansDto = data;
        },
        error: function (data, status, error) {
          try {
            console.log(data);
            swal("Error", data.responseJSON.Message, "error");
          } catch (e) {
            swal("Error", e, "error");
          }
        },
      });
    },
    confirmPayment: function (payment) {
      var self = this;
      self.paypalPayDto.Status = payment.state;
      self.paypalPayDto.PaypalEmail = payment.payer.payer_info.email;
      self.paypalPayDto.PaypalFirstName = payment.payer.payer_info.first_name;
      self.paypalPayDto.PaypalLastName = payment.payer.payer_info.last_name;
      self.paypalPayDto.InvoiceNumber = payment.transactions[0].invoice_number;
      self.paypalPayDto.PaypalTransId =
        payment.transactions[0].related_resources[0].sale.id;
      self.paypalPayDto.PaypalAmount =
        payment.transactions[0].related_resources[0].sale.amount.total;
      self.paypalPayDto.PaypalCurrency =
        payment.transactions[0].related_resources[0].sale.amount.currency;
      self.paypalPayDto.PlanId = self.selectedPlan.PlanId;
      fbq("track", "Purchase", {
        currency: "USD",
        content_name: self.selectedPlan.Description,
        value: self.selectedPlan.TotalPrice,
      });
      self.$ga.event(
        "Purchase Completed",
        self.selectedPlan.Description,
        self.selectedPlan.TotalPrice + " USD",
        self.selectedPlan.TotalPrice
      );
      self.submitPaymentDto(self.paypalPayDto);
    },
    submitPaymentDto: function (paypalPayment) {
      //we only reach here if the payment was in state='approved', so should be successful call.
      var self = this;
      self.hidePaypalModal();
      $.ajax({
        type: "POST",
        contentType: "application/json",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        data: JSON.stringify(paypalPayment),
        dataType: "json",
        url: "https://www.dupaws.com/services/api/confirmPayment",
        success: function (data) {
          if (data.SubscriptionId == null) {
            swal(
              "Payment Error",
              "Please contact support immediately and provide the invoice number: " +
                paypalPayment.InvoiceNumber,
              "error"
            );
          }
          self.hidePendingModal();
          swal(
            {
              title: "Payment successfull",
              text:
                "Payment with Invoice Number: " +
                data.InvoiceNumber +
                " was success, thank you!",
              type: "success",
              confirmButtonClass: "btn-success",
              confirmButtonText: "Woof",
              timer: 500,
            },
            function () {
              self.$router.push({ path: "/success/" + data.SubscriptionId });
            }
          );
        },
        error: function () {
          try {
            swal(
              "Payment Error",
              "Please contact support immediately and provide the invoice number: " +
                paypalPayment.InvoiceNumber,
              "error"
            );
          } catch (e) {
            swal(
              "Payment Error",
              "Please contact support immediately and provide the invoice number: " +
                paypalPayment.InvoiceNumber,
              "error"
            );
          }
        },
      });
    },
    initPaypalButton() {
      var self = this;
      if (self.paypalDone == true)
        //do not init Paypal button twice..
        return;
      paypal.Button.render(
        {
          locale: "en_AE",
          commit: true,
          style: {
            layout: "vertical", // horizontal | vertical
            size: "responsive", // medium | large | responsive
            shape: "rect", // pill | rect
            color: "gold", // gold | blue | silver | black
          },
          onClick: function () {
            // This handler will be called for every click on the PayPal button
            self.hidePaypalModal();
            self.showPendingModal();
          },
          funding: {
            allowed: [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT],
            disallowed: [],
          },
          client: {
            sandbox:
              "AZES99kM2cu_67z3ijKQrf4BByAPzPqiVrIruRWz48LFyUvFjHi60BpvczS5ixrP2RTL8JADjgya8eSV",
            production:
              "AfBinNS7DZc6ujcGkHaau5GgG_DcoYVwljPl7njs-zam-Aguc79nP7RYGHOiZIKQma45njhJHq35fB7N",
          },
          env: "production", // sandbox | production
          payment: function () {
            var env = this.props.env;
            var client = this.props.client;
            // self.REST.funding_instruments = self.funding_instruments
            return paypal.rest.payment.create(env, client, self.paymentDto);
          },
          onCancel: function (data, actions) {
            self.hidePaypalModal();
            self.hidePendingModal();
            swal("Oops", "You cancelled this transaction", "error");
          },
          onError: function (actions, err) {
            self.hidePendingModal();
            self.hidePaypalModal();
            swal(
              "Oops Paypal error",
              "Seems like paypal duplicate invoice_number or paypal generic server error",
              "error"
            );
          },
          // Wait for the payment to be authorized by the customer
          onAuthorize: function (data, actions) {
            //console.log(data)
            return actions.payment.execute().then(function (payment) {
              if (payment.state == "approved") {
                //payment success.
                self.confirmPayment(payment);
              } else {
                //try again.
                self.hidePendingModal();
                self.hidePaypalModal();
                swal(
                  "Payment failure",
                  "Payment was not approved, status: " +
                    payment.state +
                    ", please try again",
                  "error"
                );
              }
            });
          },
        },
        "#paypal-button-container"
      );
    },
  },
  computed: {
    authenticatedComp: function () {
      return store.getters.authenticated;
    },
    userRoleComp: function () {
      return store.getters.userRole;
    },
    subscriptionComp: function () {
      return store.getters.SubscriptionStatus.IsActive;
    },
    subscriptionAllowedComp: function () {
      return store.getters.SubscriptionStatus.IsValid;
    },
  },
};
</script>

<style scoped>
.ribbon {
  width: 160px;
  height: 32px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  background: linear-gradient(#9bc90d 0%, #79a70a 100%);

  transform: rotate(45deg);
  position: absolute;
  right: -42px;
  top: 20px;
  padding-top: 7px;
}

.modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
.paypal-container {
  padding: 15px;
}

.activatePaypal {
  pointer-events: none;
  opacity: 0.3;
}

.pricing-card-title {
  color: rgb(254, 179, 79);
  font-family: serif !important;
}

.font-weight-normal {
  font-weight: 400 !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  font-size: 1.5rem;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-body {
  background-color: white;
  padding: 0px;
  overflow: hidden;
  position: relative;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  border-radius: 5px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// Subscribe.vue?0f1d480b